export default {
  /*
   * Sum dữ liệu đang hiển thị
   */
  Sum: 'sum',
  /*
   * Sum tất cả dữ liệu trong store
   */
  SumAll: 'sumAll',
  /*
   * Trung bình
   */
  Avg: 'avg',
  /*
   * Nhỏ nhất
   */
  Min: 'min',
  /*
   * Lớn nhất
   */
  Max: 'max',
  /*
   * Text custom
   */
  Text: 'text',
  /**
   * Dòng tổng ở footer
   */
  RowCount: 'RowCount'
};
